import { Box, Card, Divider, Stack, Typography } from '@mui/material';
import { COLOR_BG_SECONDARY, formatForDisplay } from 'shared';

interface PackageCardProps {
  name: string;
  image: string;
  price: number;
  daily: { crat: number; cit: number };
  units: { available: number; total: number };
}

export const PackageCard = ({ name, image, price, daily, units }: PackageCardProps) => {
  return (
    <Card className="blur" sx={{ p: 3 }}>
      <Stack direction="row" justifyContent="space-between">
        <Stack>
          <Typography variant="h5" className="primary" mb={3}>
            {name}
          </Typography>

          <Stack mb={2}>
            <Typography variant="body2" className="secondary">
              License Price
            </Typography>
            <Typography variant="h5" className="accent">
              ${formatForDisplay(price, 0, true)}
            </Typography>
          </Stack>

          <Typography variant="body2" className="secondary">
            Daily
          </Typography>
        </Stack>

        <Box
          maxWidth={{ xs: 97, sm: 110, md: 130 }}
          maxHeight={{ xs: 97, sm: 110, md: 130 }}
          borderRadius="50%"
          bgcolor={COLOR_BG_SECONDARY}
          padding="18px"
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Box
            component="img"
            alt={`package ${name}`}
            src={image}
            sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
        </Box>
      </Stack>

      <Stack direction="row" alignItems="center" gap={1} mb={2}>
        <Typography variant="body2" className="primary" noWrap>
          {formatForDisplay(daily.crat, 2, true)} CRAT
        </Typography>
        <Divider
          orientation="vertical"
          sx={{
            height: '12px',
          }}
        />
        <Typography variant="body2" className="primary" noWrap>
          {formatForDisplay(daily.cit, 2, true)} CIT
        </Typography>
      </Stack>

      <Box
        height={34}
        borderRadius={2}
        bgcolor={COLOR_BG_SECONDARY}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="body2" className="primary">
          {units.available}{' '}
          <Typography component="span" className="secondary">
            |
          </Typography>{' '}
          {units.total} units available
        </Typography>
      </Box>
    </Card>
  );
};
